export default __webpack_public_path__ + "static/media/roundSternLogo.5fa71a57.png";